import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcTracking = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 40 40",
  iconname: "IconIcTracking"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip0_18977_9184)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 0.5H34C37.0376 0.5 39.5 2.96243 39.5 6V34C39.5 37.0376 37.0376 39.5 34 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z",
  fill: "white",
  stroke: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 22.4483H10.7778V29H7V22.4483ZM14.5556 9.5H18.3333V29H14.5556V9.5ZM22.1111 14.5862H25.8889V29H22.1111V14.5862ZM29.6667 18.5172H33.4444V29H29.6667V18.5172Z",
  fill: "#7B61FF"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip0_18977_9184"
}, /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  fill: "white"
}))));
export { IconIcTracking as default };
//# sourceMappingURL=IconIcTracking.js.map